import type { McpDiscoveryAuthModelDto } from '@terra/shared-contracts-mcp-servers';
import { mcpServersClient } from './mcp-servers.client';

export async function discoverMcpOAuthScopes(
  discoveryUrl: string,
): Promise<McpDiscoveryAuthModelDto | null> {
  const response = await mcpServersClient.discoverMcpOAuthScopes({
    query: { discoveryUrl },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
}
